const operator = 'c04bc7c3-903f-4804-a952-9abc0016b824'

const stagingGermanyConfig = {
  operatorUUID: operator,
  theme: 'evo-hp',
  logo: 'logo.png',
  currency: 'EUR',
  showRegions: false,
  paymentMethods: ['credit_card', 'sepa'],
  mobilePrefix: '+49',
  homeURL: 'https://evofitness.de',
  termsURL: 'https://evofitness.de/agb',
  friendlyCaptchaSitekey: 'FCMQGBDD9FICCIF7',
  locales: {
    all: ['de-DE', 'en-DE'],
    defaultLocale: 'de-DE'
  },
  tracking: {
    gtm: {
      id: 'GTM-MMFSVRH'
    },
    adtraction: {
      c: undefined,
      tp: undefined,
      ap: undefined
    }
  },
  dibs: {
    callbackURL: `https://dibs-api.staging.credlock.net/${operator}/signup`,
    test: 'yes'
  },
  mypage: {
    url: 'https://mypage-ui-de.staging.credlock.net'
  },
  // sent as return_url with the completed quote so payment returns to this host
  paymentPath: '/processing-payment'
}

export default stagingGermanyConfig
